<template>
  <v-container>
    <v-layout row wrap>
      <v-flex sm12 class="my-3">
        <h1>Create a new project</h1>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex sm12 class="my-3">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-layout row wrap>
              <v-flex sm12 class="my-3">
                <v-text-field
                  v-model="form.title"
                  :counter="60"
                  :rules="titleRules"
                  label="Title"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="form.description"
                  :rules="descriptionRules"
                  label="Description"
                ></v-text-field>

                <wysiwyg v-model="form.body" />

                <!-- <v-combobox
                  v-model="form.members"
                  label="Project Members"
                  multiple
                  chips
                ></v-combobox>-->
                <!-- <v-textarea
                  v-model="form.body"
                  :rules="bodyRules"
                  label="Body Text"
                  box
                  required
                ></v-textarea>-->

                <v-text-field v-model="form.youtube" label="Youtube Video ID" required></v-text-field>

                <v-checkbox
                  v-model="form.youtubeFeatured"
                  label="Always show youtube video instead of featured image on project page"
                  required
                ></v-checkbox>

                <v-select
                  v-model="form.projectType"
                  :items="projectTypes"
                  :rules="[v => !!v || 'Project Type is required']"
                  label="Project Type"
                  required
                ></v-select>

                <v-autocomplete
                  v-model="form.projectThemes"
                  :items="projectThemes"
                  label="Project Themes"
                  required
                  multiple
                  autocomplete
                ></v-autocomplete>
              </v-flex>

              <!-- <v-flex xs12>
                <v-autocomplete
                  v-model="form.portfolios"
                  :items="portfolios"
                  box
                  chips
                  color="blue-grey lighten-2"
                  label="Select*"
                  multiple
                >
                <template v-slot:selection="data">
                    <v-chip
                    :selected="data.selected"
                    close
                    class="chip--select-multi"
                    @input="remove(data.item)"
                    >
                      {{ data.item.title }}
                    </v-chip>
                </template>
                <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                    <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.title"></v-list-tile-title>
                    </v-list-tile-content>
                    </template>
                </template>
                </v-autocomplete>
              </v-flex>-->

              <v-flex xs12>
                <v-autocomplete
                  v-model="form.contributors"
                  :items="contributors"
                  box
                  chips
                  color="blue-grey lighten-2"
                  label="Select*"
                  multiple
                  item-text="displayName"
                  item-value="displayName"
                  return-object
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      class="chip--select-multi"
                      @input="data.parent.selectItem(data.item)"
                    >{{ data.item.displayName }}</v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.displayName"></v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <img :src="imageThumbnail.url" height="150" v-if="imageThumbnail.url" />
                <v-text-field
                  label="Thumbnail Image"
                  @click="pickFile('imageThumbnail')"
                  v-model="imageThumbnail.name"
                  prepend-icon="attach_file"
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="imageThumbnail"
                  id="imageThumbnail"
                  accept="image/*"
                  @change="onFilePicked"
                />
              </v-flex>
              <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <img :src="imageFeatured.url" height="150" v-if="imageFeatured.url" />
                <v-text-field
                  label="Featured Image"
                  @click="pickFile('imageFeatured')"
                  v-model="imageFeatured.name"
                  prepend-icon="attach_file"
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="imageFeatured"
                  id="imageFeatured"
                  accept="image/*"
                  @change="onFilePicked"
                />
              </v-flex>

              <v-flex xs12>
                <v-checkbox v-model="form.featured" label="Show on the front page" required></v-checkbox>

                <v-checkbox v-model="form.publish" label="Publish to the site" required></v-checkbox>

                <v-btn :disabled="!valid" @click="validate">Validate</v-btn>

                <!-- <span v-if="!!statusText"> -->
                {{ statusText }}
                <!-- </span> -->

                <!-- <v-btn
                  @click="reset"
                >
                  Reset Form
                </v-btn>

                <v-btn
                  @click="resetValidation"
                >
                  Reset Validation
                </v-btn>-->
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { db, storage, CurrentTime } from '@/db.js'
import camelCase from 'lodash.camelcase'
import cloneDeep from 'lodash.clonedeep'
import { dataURLToBlob } from '@/util/index.js'

export default {
  name: 'createProject',
  data: () => ({
    contributors: [],
    form: {
      title: '',
      projectType: null,
      description: '',
      body: '',
      youtube: '',
      youtubeFeatured: false,
      featured: false,
      publish: false,
      contributors: [],
      projectThemes: [],
      imageThumbnail: '',
      imageFeatured: '',
      uri: ''
    },
    imageThumbnail: {
      name: '',
      url: '',
      file: ''
    },
    imageFeatured: {
      name: '',
      url: '',
      file: ''
    },
    search: '',
    imageName: '',
    imageUrl: '',
    imageFile: '',
    valid: true,
    titleRules: [
      v => !!v || 'Title is required',
      v => (v && v.length <= 60) || 'Title must be less than 60 characters'
    ],
    descriptionRules: [v => !!v || 'Description is required'],
    bodyRules: [v => !!v || 'Description is required'],
    projectTypes: ['idea', 'prototype', 'pilot'],
    projectThemes: [
      'Credit Cards',
      'Financial Literacy',
      'Payments',
      'Technology'
    ],
    statusText: ''
  }),
  created () {
    let vm = this

    // fetch Firebase if ID is in router
    if (this.$route.params.id) {
      this.uri = this.$route.params.id

      db.collection('projects')
        .doc(this.uri)
        .get()
        .then(response => {
          vm.form = response.data()
          vm.form.body = decodeURIComponent(vm.form.body)
          vm.imageThumbnail.url = vm.form.imageThumbnail
          vm.imageFeatured.url = vm.form.imageFeatured
        })
        .catch(error => {
          throw new Error(error)
        })
    }
  },
  methods: {
    triggerSnackbar (text) {
      this.$store.dispatch('setsnackbarOptions', {
        text: text,
        btnText: 'Close'
      })
    },
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
        this.sendForm()
      }
    },
    remove (item) {
      const index = this.form.contributors.indexOf(item.title)
      if (index >= 0) this.form.contributors.splice(index, 1)
    },
    sendForm () {
      let vm = this
      let formPayload = cloneDeep(vm.form)
      formPayload.body = encodeURIComponent(vm.form.body)
      formPayload.uri = encodeURIComponent(camelCase(formPayload.title))

      if (formPayload.createdAt) {
        formPayload.createdAt = CurrentTime
      }
      formPayload.editedAt = CurrentTime

      let contributors = []

      for (let index = 0; index < formPayload.contributors.length; index++) {
        contributors.push(
          db.doc('contributors/' + formPayload.contributors[index].uri)
        )
      }

      formPayload.contributors = contributors

      if (!vm.imageFeatured.file) {
        vm.imageFeatured = vm.imageThumbnail
      } else if (!vm.imageThumbnail.file) {
        vm.imageThumbnail = vm.imageFeatured
      }

      if (!vm.imageThumbnail.file) {
        vm.sendFormPayload(formPayload)
      } else if (vm.imageThumbnail.file) {
        vm.sendFormImages(formPayload)
      }
    },
    sendFormImages (formPayload) {
      let vm = this

      storage
        .images(vm.imageThumbnail.name)
        .put(vm.imageThumbnail.file)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => {
          formPayload.imageThumbnail = url

          storage
            .images(vm.imageFeatured.name)
            .put(vm.imageFeatured.file)
            .then(snapshot => snapshot.ref.getDownloadURL())
            .then(url => {
              formPayload.imageFeatured = url

              vm.sendFormPayload(formPayload)
            })
            .catch(error => {
              vm.triggerSnackbar('Failed to update to database:' + error)
              throw new Error(error)
            })
        })
        .catch(error => {
          vm.triggerSnackbar('Failed to update to database:' + error)
          throw new Error(error)
        })
        .catch(error => {
          vm.triggerSnackbar('Failed to update to database:' + error)
          throw new Error(error)
        })
    },
    sendFormPayload (formPayload) {
      let vm = this
      db.collection('projects')
        .doc(formPayload.uri)
        .set(formPayload, {
          merge: true
        })
        .then(() => {
          vm.triggerSnackbar('Successful write to database')
        })
        .catch(error => {
          vm.triggerSnackbar('Failed to update to database:' + error)
          throw new Error(error)
        })
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    pickFile (ref) {
      this.$refs[ref].click()
    },
    onFilePicked (e) {
      const target = e.path['0'].id
      const files = e.target.files
      if (files[0] !== undefined && files[0].type.match(/image.*/)) {
        this[target].name = files[0].name
        if (this[target].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this[target].url = fr.result
          this[target].file = files[0] // this is an image file that can be sent to server...
          // TODO this.resizePhoto(fr.result)
        })
      } else {
        this[target].name = ''
        this[target].file = ''
        this[target].url = ''
      }
    }
  },
  firestore: {
    // portfolios: db.collection('portfolios'),
    contributors: db.collection('contributors')
  }
}
</script>
